import React, { useEffect, useRef } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from 'lenis';
import { trackStep } from './lib/track';
import HammerLanding from './pages/HammerLanding';
import FaqPage from './pages/FaqPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import SmsTerms from './components/SmsTerms';

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, anchors: true });
    return () => lenis.destroy();
  }, []);

  // Funnel tracking: visited + scroll-depth milestones (stitched per tab by
  // session id; flows to GHL once REACT_APP_GHL_WEBHOOK_URL is set)
  const marked = useRef({});
  useEffect(() => {
    trackStep('visited');
    const onScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const depth = total > 0 ? (window.scrollY / total) * 100 : 0;
      for (const pct of [50, 90]) {
        if (depth >= pct && !marked.current[pct]) {
          marked.current[pct] = true;
          trackStep(`scroll_${pct}`);
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HammerLanding />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/sms-terms" element={<SmsTerms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
